<template>
  <b-dropdown-item :active="selected" @click="$emit('selected', item)">
    {{ item.name }}
  </b-dropdown-item>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
    selected: { type: Boolean, required: true },
  },
}
</script>
